// extracted by mini-css-extract-plugin
export default {"container":"Count_container__kj87C","number":"Count_number__SjTCB","note":"Count_note__SiOHw","btn":"Count_btn__hDg2F","externalLinkIcon":"Count_externalLinkIcon__l9429"};